import { Component, OnInit, Input } from "@angular/core";
//Services
import { CredentialsService } from "src/app/services/credentials/credentials.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { RouterService } from "src/app/services/router/router.service";
import { OrdersService } from 'src/app/services/orders/orders.service';
import { LoadingController, Platform } from "@ionic/angular";
import { AlertService } from "src/app/services/alert/alert.service";

@Component({
  selector: 'app-orders',
  templateUrl: './orders.page.html',
  styleUrls: ['./orders.page.scss'],
})
export class OrdersPage implements OnInit {
  checkProcessing: boolean = false
  checkDelivered: boolean = false
  checkConfirm: boolean = false
  checkCancelled: boolean = false
  checkAll: boolean = false;
  loader: boolean;
  orders: any;
  temp: any;
  ordersFilter: any;
  linesSkeletonText = Array.from({ length: 10 }, (_, idx) => `${++idx}`);
  lang;
  loading: boolean = false;
  isSmallScreen = true;
  stateFlag: boolean = false;
  stateInfo: string = '';
  public showOrders: boolean = false;
  constructor(
    private credentialsService: CredentialsService,
    private routerService: RouterService,
    public languageService: LanguagesService,
    private orderService: OrdersService,
    public platform: Platform,
    private loadingController: LoadingController,
    public alertService: AlertService
  ) { }

  async ngOnInit() {
    this.lang = this.languageService.language;
    this.callOrders();
    if (this.platform.width() > 721) this.isSmallScreen = false;

  }

  async ionViewDidEnter() {
    const loading = await this.loadingController.create({
      message: 'Cargando'
    });
    loading.present();
    await this.callOrders();

    loading.dismiss();
  }

  orderSelected(order): void {
    if (this.platform.is("desktop")) {
      this.routerService.redirect(`app/profile/orders/${order}`);
    } else {
      this.routerService.redirect(`profile/orders/${order}`);
    }
  }

  get getTextIUOrders() {
    return this.languageService.textsIU.page_orders;
  }

  async callOrdersFilter(event) {
    this.loading = true;
    this.ordersFilter = [];
    // Filtro por estado de los pedidos
    if (event.target.id == "collected") {
      this.ordersFilter = this.temp.filter(x => {
        if (x.deliveries) {
          const hasConfirmReceived = Object.keys(x.deliveries[0]).includes('confirmReceivedData')
          return hasConfirmReceived
        }
      });
      console.log("this.ordersFilter1", this.ordersFilter);
      if (this.ordersFilter.length == 0) {
        this.stateFlag = true;
        this.stateInfo = "Recibido";
      }

      this.loading = false;
      return
    }

    if (event.target.id == "processing") {
      this.ordersFilter = this.temp.filter(x => {
        const state = x.state === "processing" || x.state === "collected";
        if (x.deliveries) {
          const hasConfirmReceived = Object.keys(x.deliveries[0]).includes('confirmReceivedData')
          return !hasConfirmReceived && state
        }
      })
      console.log("this.ordersFilter2", this.ordersFilter);
      if (this.ordersFilter.length == 0) {
        this.stateFlag = true;
        this.stateInfo = "En Proceso";
      }
      this.loading = false;
      return
    }

    this.ordersFilter = this.temp.filter(x => x.state === event.target.id);
    this.loading = false;

    console.log("this.ordersFilter3", this.ordersFilter);
    if (this.ordersFilter.length == 0) {
      this.stateFlag = true;
      this.stateInfo = (event.target.id == 'cancelled') ? "Cancelado" : ((event.target.id == 'delivered') ? 'Entregado' : event.target.id);
    }
  }

  reset() {
    this.stateFlag = false;
    this.ordersFilter = [...this.temp]
  }

  async callOrders() {
    this.loader = true;
    this.orders = await this.orderService.getOrders();
    this.orders.data.length == 0
      ? (this.showOrders = false)
      : (this.showOrders = true);
    let deliveries = [];
    // Instancia todos los estados que llegan vacio como processing antes del filtro
    this.orders.data?.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    this.orders.data.map((order: any) => {
      order.deliveries.map((deliverie) => {
        if (order.address) {
          deliverie.address = order.address;
        }
        if (!deliverie.state) {
          deliverie.state = "processing";
        }
        deliverie.product = order.product;
        deliverie.totalPoints = order.totalPoints;
        deliverie.quantity = order.quantity;
        deliverie.deliveries = order.deliveries
        deliveries.push(deliverie);
      });
    });

    this.loader = false;
    this.temp = [...deliveries];
    this.ordersFilter = [...deliveries];
    console.log("this.ordersFilter", this.ordersFilter);
    //this.ordersFilter = [...deliveries].filter(x => x.state === "processing" || x.state === "collected");
  }

  callOrdersFilterDefault() {
    if (this.temp) {
      this.ordersFilter = this.temp.filter(x => x.state === "processing" || x.state === "collected");
    }
  }
  async confirmOrder(order: any) {
    try {
      console.log("order", order);
      const result = await this.orderService.confirmOrder(order);
      console.log("result order", result);
      if (result && result['code'] == 'updated') {
        this.alertService.showAlert('Se ha confirmado el recibido.');
        await this.callOrders();
      }
    } catch (error) {
      console.log("error confirm, order", error);
      throw new Error(error);

    }
  }

}
